app.config(function ($translateProvider) {
    $translateProvider.translations('nl', {
        MAX: 'Max {{value}}',
        MIN: 'Min {{value}}',
        REQUIRED: 'Verplicht',
    });
});
